import { render, staticRenderFns } from "./PolygonPanel.vue?vue&type=template&id=5688a26e&"
import script from "./PolygonPanel.vue?vue&type=script&lang=js&"
export * from "./PolygonPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports